/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для страницы заказа
   */
  app.OrderView = app.View.extend({
    additionalOptions: ['faderView'],
    run: function () {
      this.initChildViews();
      this.listenTo(this.childViews.tabsOrderHistoryView, 'tab:selected', this.onTabSelected);
    },

    /**
     * Инициализирует дочерние виды
     */
    initChildViews: function () {
      this.childViews.messageToManagerFormView = new app.MessageToManagerFormView();
      this.childViews.orderItemView = new app.OrderItemView({
        el: '.reducer',
        model: this.model,
        faderView: this.faderView,
      });
      this.childViews.getParamPaginationView = new app.GetParamPaginationView();
      this.childViews.tabsOrderHistoryView = new app.TabsOrderHistoryView({el: '.sl-tabs'});
    },

    /**
     * Обрабатывает выбор вкладки
     *
     * @param $tab jQuery-элемент вкладки
     * @param $tabContent jQuery-элемент содержимого вкладки
     */
    onTabSelected: function ($tab, $tabContent) {
      if ($tab instanceof $ && $tabContent instanceof $) {
        app.helpers.DomHelper.resizeTextarea($tabContent.find('.js-jp-order-comment-field'));
      }
    },
  });
})(jQuery);

}.call(window));